import React from "react"
import { useStaticQuery, graphql} from "gatsby"
import PdfThumb from '../PdfThumb'
import './filelister.css'


const FileLister = () => {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: {extension: {eq: "pdf"}}) {
        nodes {
          dir
          name
          extension
          publicURL
        }
      }
    }
  `)
  return (
    <div className="filelister">
      {
        data.allFile.nodes.map( file => {
          return (
            <a href={file.publicURL} target="_blank" rel="noopener noreferrer" >
              <PdfThumb pdfFile={file.publicURL} />
            </a>
          )
        })
      }
    </div>
  )
  // <pre>{JSON.stringify(data, null, 4)}</pre>
  
}

export default FileLister
